<div class="receipt-container">
    <div id="pdfExport" #pdfExport>
        <div class="receipt-container-transaction-info rounded mx-2 mt-4 p-2 mx-4 d-flex flex-column justify-content-between align-items-center">
            <div class="amount">Amount</div>
            <div class="total">
                {{ info.total }} <span class="currency">{{ info.currency }}</span>
            </div>
            <div *ngIf="!errorObj.error" class="transaction-type d-flex justify-content-end align-items-center rounded-pill px-2 mt-2 capitalise">
                <mat-icon svgIcon="success"></mat-icon> {{ screen }} successful
            </div>
            <div *ngIf="errorObj.error" class="transaction-type-error d-flex justify-content-end align-items-center rounded-pill px-2 mt-2 capitalise">
                <mat-icon svgIcon="failure"></mat-icon> {{ screen }} failed
            </div>
            <div class="ref mt-3">Ref: {{ info.refId }} | {{ info.date | date : 'dd/M/YYYY' }}</div>
        </div>

        <div class="receipt-container-error-container rounded mx-4 p-2 mt-3" *ngIf="errorObj.error">
            <div class="error-title">{{ errorObj.error }}</div>
            <div class="error-message">{{ errorObj.message }}</div>
        </div>

        <div class="receipt-container-summary-info d-flex flex-column mx-4">
            <div class="summary-title px-2 mb-2">summary</div>
            <div class="container rounded d-flex flex-column justify-content-center">
                <div class="amount d-flex justify-content-between py-1 px-2">
                    <div>{{ screen + ' Amount' }}</div>
                    <div>{{ info.cashAmount }} {{ info.currency }}</div>
                </div>
                <div class="fee d-flex justify-content-between py-1 px-2">
                    <div>Fee</div>
                    <div>{{ info.fee }} {{ info.currency }}</div>
                </div>
                <div class="total d-flex justify-content-between py-1 px-2">
                    <div>Total</div>
                    <div>{{ info.total }} {{ info.currency }}</div>
                </div>
            </div>
        </div>

        <div class="receipt-container-basic-info rounded mx-4 p-2 mt-4">
            <div class="receipt-container-basic-info-title">{{ screen === 'cash-in' ? 'Receiver Details' : 'Requesting account' }}</div>
            <div class="d-flex flex-column justify-content-center align-items-center">
                <!-- <img [src]="info.imgUrl" alt="" class="rounded-circle img-size" /> -->
                <div class="font-weight-bold fs-5">{{ info.name }}</div>
                <div class="wallet-info">SDG Wallet : {{ info.walletId }}</div>
                <hr class="full-width" />
                <div class="client-info d-flex justify-content-between align-items-center">
                    <div class="email pe-3 border-end">{{ info.email }}</div>
                    <div class="mobile px-3">{{ info.mobile }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="receipt-container-footer m-4 mb-2 d-flex justify-content-start align-items-center">
        <hr />
        <button
            [disableRipple]="true"
            class="rounded-pill text-white receipt-container-footer-btn btn me-2"
            color="primary"
            mat-flat-button
            (click)="handleDownloadPdf()"
        >
            <span>Download receipt</span>
        </button>
        <button (click)="dialogRef.close()" mat-raised-button class="btn-secondary rounded-pill mx-2">Done</button>
    </div>
</div>
